import { Svg } from 'components/svg'

export const CalendarIcon = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M16.482,20.169h-14a2,2,0,0,1-2-2v-14a2,2,0,0,1,2-2h2v-2h2v2h6v-2h2v2h2a2,2,0,0,1,2,2v14A2,2,0,0,1,16.482,20.169Zm-14-12v10h14v-10Zm0-4v2h14v-2Zm12,12h-2v-2h2Zm-4,0h-2v-2h2Zm-4,0h-2v-2h2Zm8-4h-2v-2h2Zm-4,0h-2v-2h2Zm-4,0h-2v-2h2Z"
      transform="translate(2.518 1.831)"
      fill="currentColor"
    />
  </Svg>
)
